import {
  setSharedRuntimeContext,
  ToastProvider,
  TranslationContext,
} from "@3sc/common-component";
import React, { useEffect } from "react";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Network from "./components/Network";
import Routing from "./routers/Routing";
import "./style/sass/main.scss";
import { useTranslation } from "react-i18next";
import AnalyticsRouterSync from "./components/AnalyticsRouterSync";
import AnalyticsSessionSync from "./components/AnalyticsSessionSync";
import { AuthProvider, useAuth } from "./provider/AuthContext";
import { defaultHistory } from "./history";

function LanguageSync() {
  const { i18n } = useTranslation();
  const { settings } = useAuth();
  const lang = settings?.platform?.language;

  useEffect(() => {
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  useEffect(() => {
    setSharedRuntimeContext({ i18nextLng: i18n.language });
  }, [i18n.language]);

  return null;
}

function App() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <HistoryRouter history={defaultHistory} basename="scai">
        <AuthProvider>
          <TranslationContext.Provider value={{ t }}>
            <ToastProvider>
              <AnalyticsRouterSync />
              <AnalyticsSessionSync />
              <LanguageSync />
              <Layout>
                <Routing />
                <Network />
              </Layout>
            </ToastProvider>
          </TranslationContext.Provider>
        </AuthProvider>
      </HistoryRouter>
    </div>
  );
}

export default App;
